// extracted by mini-css-extract-plugin
export var col1 = "Footer-module--col1--04441";
export var container = "Footer-module--container--70893";
export var copyright = "Footer-module--copyright--a775b";
export var email = "Footer-module--email--8efa6";
export var footer = "Footer-module--footer--2d913";
export var footerNav = "Footer-module--footerNav--07276";
export var h3 = "Footer-module--h3--9ea22";
export var logo = "Footer-module--logo--2eef9";
export var logoImage = "Footer-module--logoImage--dc86e";
export var logoText = "Footer-module--logoText--81fc6";
export var socialLinks = "Footer-module--socialLinks--4c322";